import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function CouplesTestimonials() {
  const images = [{
    src: 'https://cdn.magicpatterns.com/uploads/atVcTuMdxpr9vDxJ5spt8q/WhatsApp_Image_2026-03-12_at_22.18.01_1.webp',
    alt: 'Testimonio de pareja - Ceremonia simbólica'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/kmwzfpVemB7TdLuTpUXby7/WhatsApp_Image_2026-03-12_at_22.18.02_(1)_1.webp',
    alt: 'Testimonio de pareja - Ceremonia de bienvenida'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/2N1FqA3B6fPzUr7vigguqw/WhatsApp_Image_2026-03-12_at_22.18.02_(2)_1.webp',
    alt: 'Testimonio de pareja - Ceremonia de renovación'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/m1LnmW32HgYM7S9frR5XiK/WhatsApp_Image_2026-03-12_at_22.18.02_(3)_1.webp',
    alt: 'Testimonio de pareja - Ceremonia de unión'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/jdtRg4UuigbeFtLb8XdY2F/WhatsApp_Image_2026-03-12_at_22.18.02_1.webp',
    alt: 'Testimonio de pareja - Ceremonia personalizada'
  }];
  const [current, setCurrent] = useState(0);
  const goNext = () => {
    setCurrent(prev => (prev + 1) % images.length);
  };
  const goPrev = () => {
    setCurrent(prev => (prev - 1 + images.length) % images.length);
  };
  return <section className="bg-cream-light py-14 md:py-20 relative" data-id="element-33">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-[1px] bg-gold-main/50" data-id="element-34"></div>

      <div className="max-w-4xl mx-auto px-6" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 space-y-3" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-brown-dark" data-id="element-37">
            Testimonios de parejas
          </h2>
          <p className="text-xl font-playfair italic text-gold-dark" data-id="element-38">
            Ceremonias Simbólicas realizadas por Paula Giraldo
          </p>
        </motion.div>

        {/* Carousel */}
        <div className="relative" data-id="element-39">
          <div className="flex items-center gap-4" data-id="element-40">
            <button onClick={goPrev} className="flex-shrink-0 w-12 h-12 rounded-full border border-gold-main/30 bg-cream-dark flex items-center justify-center text-gold-main hover:bg-gold-main hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-gold-main/50" aria-label="Imagen anterior" data-id="element-41">
              <ChevronLeftIcon className="w-5 h-5" data-id="element-42" />
            </button>

            <div className="flex-1 overflow-hidden" data-id="element-43">
              <AnimatePresence mode="wait" data-id="element-44">
                <motion.div key={current} initial={{
                opacity: 0,
                x: 40
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: -40
              }} transition={{
                duration: 0.35,
                ease: 'easeInOut'
              }} className="rounded-sm overflow-hidden shadow-lg" data-id="element-45">
                  <img src={images[current].src} alt={images[current].alt} className="w-full h-auto object-cover" loading="lazy" data-id="element-46" />
                </motion.div>
              </AnimatePresence>
            </div>

            <button onClick={goNext} className="flex-shrink-0 w-12 h-12 rounded-full border border-gold-main/30 bg-cream-dark flex items-center justify-center text-gold-main hover:bg-gold-main hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-gold-main/50" aria-label="Siguiente imagen" data-id="element-47">
              <ChevronRightIcon className="w-5 h-5" data-id="element-48" />
            </button>
          </div>

          {/* Dots indicator */}
          <div className="flex justify-center gap-2 mt-5" data-id="element-49">
            {images.map((_, idx) => <button key={idx} onClick={() => setCurrent(idx)} className={`w-2.5 h-2.5 rounded-full transition-colors focus:outline-none ${idx === current ? 'bg-gold-main' : 'bg-gold-main/25'}`} aria-label={`Ir a imagen ${idx + 1}`} data-id="element-50" />)}
          </div>
        </div>
      </div>
    </section>;
}